module.exports = __webpack_public_path__ + "static/img/logoNation.c25580f3.jpg";